import { createAction, props } from '@ngrx/store';
import { GridTableState } from '../../models/grid-customization.model';

export const saveGridState = createAction(
  '[Grid Customization] Save Grid State',
  props<{ gridId: string; state: GridTableState }>()
);

export const resetGridState = createAction(
  '[Grid Customization] Reset Grid State',
  props<{ gridId: string }>()
);

export const resetAllGridsState = createAction(
  '[Grid Customization] Reset All Grids State'
);

